module.exports = __webpack_public_path__ + "img/arrow_left_circle.b8a1d357.svg";